// Product card swatches: colour swatch clicks, the "Size | Colour" label under
// each card, and the card-wide click-through.
//
// Moved out of snippets/card-product.liquid, which printed this whole script
// inline once per card - 20 copies (~180 KB) on the homepage, each parsed and
// each registering its own DOMContentLoaded pass over every card. Loaded once,
// deferred, from layout/theme.liquid. It still re-initialises cards added later
// (AJAX filters, quick-add) through the MutationObserver below.
(function() {
var SIZE_OPTION_NAMES_CP = [
  'size',
  'pack',
  'packing',
  'volume',
  'capacity',
  'weight',
  'litre',
  'liter',
  'ml',
  'qty',
  'quantity'
];
  // Character limit for the "Size | Color" label by viewport width:
  //   1240–1440px → 30, 1040–1240px → 20, 750–1040px → 18, 320–520px → 20,
  //   otherwise → 35.
  function swatchCharLimit() {
    var w = window.innerWidth;
    if (w >= 1240 && w <= 1440) return 30;
    if (w >= 1040 && w < 1240) return 20;
    if (w >= 750 && w < 1040) return 18;
    if (w >= 320 && w <= 520) return 20;
    return 35;
  }
  function truncateSwatchLabel(full, lim) {
    return full.length > lim ? full.slice(0, lim) + '…' : full;
  }
  // Re-apply the limit to every selected label using the full text kept in title
  function fitAllSwatchLabels() {
    var lim = swatchCharLimit();
    document.querySelectorAll('.quick-size .size-swatch.is-selected').forEach(function (btn) {
      var full = btn.title || btn.textContent.trim();
      btn.title = full;
      btn.textContent = truncateSwatchLabel(full, lim);
    });
  }

  function renderSizes(card, swatch) {
    var sizesJson = swatch.getAttribute('data-sizes') || '[]';
    var selectedSizeId = parseInt(swatch.getAttribute('data-selected-size') || swatch.getAttribute('data-variant-id') || '0', 10);
    var sizes = [];
    try { sizes = JSON.parse(sizesJson); } catch(e) {}
    var sizeContainer = card.querySelector('.quick-size');
    if (!sizeContainer) return;
    sizeContainer.classList.add('quick-size--label');
    sizeContainer.innerHTML = '';

    var sizeOptName = (swatch.getAttribute('data-size-option') || '').toLowerCase().trim();
    var isSizeOption = SIZE_OPTION_NAMES_CP.some(function(n) { return sizeOptName.indexOf(n) !== -1; });
    var colorName = swatch.getAttribute('aria-label') || '';
    var colorLabel = (colorName === 'No Color' || !colorName) ? null : colorName;

    var selectedSz = null;
    var sizeLabel = null;
    if (sizes.length) {
      sizes.forEach(function(sz) { if (sz.id === selectedSizeId) selectedSz = sz; });
      if (!selectedSz) selectedSz = sizes[0];
      var optionValue = selectedSz && selectedSz.s ? selectedSz.s : '';
      sizeLabel = (optionValue === 'No Size' || optionValue === 'No Pack' || !optionValue) ? null : optionValue;
    }

    var packLabel = swatch.getAttribute('data-variant-pack-label') || null;
    if (packLabel === 'No Pack' || packLabel === '') packLabel = null;

    // If this card has an explicit Pack label, show it instead of the inferred size.
    if (packLabel) {
      sizeLabel = packLabel;
      isSizeOption = true;
    } else if (!isSizeOption && sizeLabel) {
      // Keep the label, even when the option name is not one of the expected
      // size/pack keywords. This prevents the JS render from dropping a server-
      // side pack label on page load.
      isSizeOption = true;
    }

    function addLine(text, extraClass) {
      var span = document.createElement('span');
      span.className = 'size-swatch size-swatch--label is-selected' + (extraClass ? ' ' + extraClass : '');
      span.title = text;
      span.textContent = truncateSwatchLabel(text, swatchCharLimit());
      sizeContainer.appendChild(span);
    }

    // Some products carry both values in a single option (e.g. "1 Ltr | Bright
    // Tones Mixed") — split any embedded pipe so it still renders as separate lines.
    function splitAndAddLine(text, extraClass) {
      text.split('|').forEach(function (part) {
        part = part.trim();
        if (part) addLine(part, extraClass);
      });
    }

    // Both real, distinct fields — one line each, no further splitting even if
    // either value happens to contain a "|". Only split when there's just one
    // field (no separate size), since that single value may carry both parts.
    if (colorLabel && sizeLabel) {
      addLine(colorLabel);
      addLine(sizeLabel, selectedSz && !selectedSz.a ? 'size-swatch--sold-out' : '');
    } else if (colorLabel) {
      splitAndAddLine(colorLabel);
    } else if (sizeLabel) {
      splitAndAddLine(sizeLabel, selectedSz && !selectedSz.a ? 'size-swatch--sold-out' : '');
    }
  }

  function initCardSwatches() {
    // Attach listeners to swatches that haven't been initialized yet
    document.querySelectorAll('.product-card__swatch:not([data-cp-sw-init])').forEach(function(swatch) {
      swatch.setAttribute('data-cp-sw-init', '1');

      // Tooltip is rendered via CSS (::after) using aria-label, so no native title needed

      swatch.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        var card = swatch.closest('.card');

        card.querySelectorAll('.product-card__swatch')
          .forEach(function(s) { s.classList.remove('is-selected'); s.style.border = ''; });
        swatch.classList.add('is-selected');
        swatch.style.border = '1px solid #e91e8c';

        var mediaDiv = card && card.querySelector('.card__media .media');
        var mainImg = mediaDiv && mediaDiv.querySelector('img');
        var variantImg = swatch.getAttribute('data-variant-image');
        var variantImg2 = swatch.getAttribute('data-variant-image-2');
        var variantUrl = swatch.getAttribute('data-variant-url');

        card.querySelectorAll('.full-unstyled-link-slider').forEach(function(anchor) {
          anchor.href = variantUrl;
        });

        if (mainImg && variantImg) {
          mainImg.src = variantImg;
          mainImg.srcset = variantImg + ' 533w';
        }

        var noImageUrl = 'https://cdn.shopify.com/s/files/1/0982/7034/7445/files/noimage.gif?v=1768217749';
        var secondImg = mediaDiv && mediaDiv.querySelector('img.ww');
        if (variantImg2 && variantImg2 !== noImageUrl) {
          if (secondImg) {
            secondImg.src = variantImg2;
            secondImg.srcset = variantImg2 + ' 533w';
            secondImg.style.display = '';
          } else if (mediaDiv) {
            var newImg = document.createElement('img');
            newImg.className = 'motion-reduce ww';
            newImg.src = variantImg2;
            newImg.srcset = variantImg2 + ' 533w';
            newImg.alt = '';
            newImg.loading = 'lazy';
            mediaDiv.appendChild(newImg);
          }
        } else if (secondImg) {
          // No real second image: REMOVE the element (don't just hide it) so the
          // main image becomes :only-child again. A display:none sibling still
          // makes the main image :not(:only-child), so the hover rule
          // `img:first-child:not(:only-child){opacity:0}` fades it out and the
          // white media background shows through on hover.
          secondImg.remove();
        }

        renderSizes(card, swatch);
      }); // click end
    });

    // Auto-select first swatch for cards not yet initialized
    document.querySelectorAll('.card:not([data-cp-init])').forEach(function(card) {
      card.setAttribute('data-cp-init', '1');
      var firstSwatch = card.querySelector('.product-card__swatch');
      if (firstSwatch) {
        firstSwatch.classList.add('is-selected');
        firstSwatch.style.border = '1px solid #e91e8c';
        renderSizes(card, firstSwatch);
      }
    });
  }

  // Re-initialize after AJAX filter/search updates replace the product grid
  if (!window._cpObserverSet) {
    window._cpObserverSet = true;
    var _cpTimer = null;
    var _cpObserver = new MutationObserver(function() {
      clearTimeout(_cpTimer);
      _cpTimer = setTimeout(function() {
        if (document.querySelector('.product-card__swatch:not([data-cp-sw-init])')) {
          initCardSwatches();
        }
      }, 50);
    });
    _cpObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (!window._cpDocClickSet) {
    window._cpDocClickSet = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('button')) return;
      var card = e.target.closest('.card');
      if (!card) return;
      var link = card.querySelector('a.full-unstyled-link-slider');
      if (!link || !link.href) return;
      window.location.href = link.href;
    });
  }

  function cpInit() {
    initCardSwatches();
    fitAllSwatchLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cpInit);
  } else {
    cpInit();
  }
  if (!window._cpLoadSet) {
    window._cpLoadSet = true;
    window.addEventListener('load', cpInit);
  }

  // Re-apply the character limit when the viewport crosses the 1240–1440 range
  if (!window._cpResizeSet) {
    window._cpResizeSet = true;
    var _cpResizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(_cpResizeTimer);
      _cpResizeTimer = setTimeout(fitAllSwatchLabels, 150);
    });
  }

})();
